import React, { Component } from 'react';

class AppError extends Component {


  render() {
    return <p>Ha ocurrido un error. La ruta que está intentando ver no existe.</p>
  }

}

export default AppError;



// WEBPACK FOOTER //
// ./src/components/App/AppError.js